<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  totalInvitees: {
    type: Number,
    default: 0,
  },
});

const searchQuery = ref('');

const filteredItems = computed(() => {
  const term = searchQuery.value.toLowerCase().trim();

  if (!term) return props.items;

  return props.items.filter(item =>
    String(item.code).toLowerCase().includes(term)
  );
});
</script>

<template>
  <div class="w-full">
    <input
      v-model="searchQuery"
      type="text"
      class="w-full px-2 py-1 border rounded-md border-slate-200 dark:border-slate-800"
      :placeholder="$t('CONTACT_PANEL.REFERRAL_CODES_LIST.SEARCH')"
    />

    <div class="max-h-[200px] overflow-y-auto space-y-1 pr-1 custom-scrollbar">
      <div
        v-if="items.length > 0 && filteredItems.length === 0"
        class="text-xs text-center text-slate-400 py-2"
      >
        {{ $t('CONTACT_PANEL.REFERRAL_CODES_LIST.SEARCH_NOT_FOUND') }}
      </div>

      <div
        v-for="item in filteredItems"
        :key="item.id"
        class="flex items-center justify-between w-full px-2 py-1.5 bg-slate-50 dark:bg-slate-800/50 rounded border border-slate-100 dark:border-slate-800"
      >
        <span
          class="inline-flex items-center text-sm font-mono text-slate-800 dark:text-slate-200"
        >
          <span>{{ item.code }}</span>

          <span v-if="item.invitees_count > 0" class="inline-flex items-center">
            : {{ item.invitees_count }}
            <fluent-icon icon="person" size="12" class="ml-1" />
          </span>
        </span>
      </div>
    </div>
    <p class="mt-2 text-sm leading-6 text-n-slate-11">
      {{
        $t('CONTACT_PANEL.REFERRAL_CODES_LIST.TOTAL_INVITEES', {
          count: props.totalInvitees,
        })
      }}
    </p>
  </div>
</template>
